var React = require('react');

function Square (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1.6","y":"2.6","width":"7.8","height":"4.8","stroke":"white","strokeWidth":"1.2","key":0}),React.createElement("path",{"d":"M5 12.6155L1.88622 20.4H8.11378L5 12.6155Z","stroke":"white","strokeWidth":"1.2","key":1}),React.createElement("rect",{"x":"14.6","y":"14.6","width":"8.8","height":"5.8","stroke":"white","strokeWidth":"1.2","key":2}),React.createElement("circle",{"cx":"19","cy":"6","r":"3.4","stroke":"white","strokeWidth":"1.2","key":3})]);
}

Square.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Square;

Square.default = Square;
